export default {
	SET_UPDATE_PASSWORD: (state, data) => {
        state.updatePassword = {
            ...state.updatePassword,
            ...data
        };
    },
}